import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import ActionButtons from '../ActionButtons/ActionButtons';

const CustomPaper = ({
  children,
  onClear,
  onApply,
  classes,
  actionButtonText,
  resetButtonText,
  formLabelId,
}) => {
  return (
    <Paper className={classes.root}>
      {children}
      <Divider className={classes.divider} aria-hidden="true" />
      <ActionButtons
        actionButtonText={actionButtonText}
        resetButtonText={resetButtonText}
        handleClose={onApply}
        handleReset={onClear}
        isActionDisabled={false}
        formLabelId={formLabelId}
      />
    </Paper>
  );
};

CustomPaper.defaultProps = {
  onClear: () => {},
  onApply: () => {},
  classes: undefined,
  children: null,
  actionButtonText: '',
  resetButtonText: '',
  formLabelId: '',
};

CustomPaper.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  onClear: PropTypes.func,
  onApply: PropTypes.func,
  actionButtonText: PropTypes.string,
  resetButtonText: PropTypes.string,
  formLabelId: PropTypes.string,
};
export default CustomPaper;
